var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-container',{attrs:{"files":_vm.files,"allow-to-submit":_vm.isSubmittedStatus},on:{"on-download-file":_vm.onDownloadFileHandler,"on-amend-file":function($event){return _vm.onAmendFileHandler($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }